import apiClient from '../api/apiClient';

class InventoryPositionService {
  async preview(productId) {
    const response = await apiClient.get(
      `/api/v1/admin/products/${productId}/inventory-position/preview`,
    );
    return response.data;
  }

  async send(productId, { dryRun = false } = {}) {
    const response = await apiClient.post(
      `/api/v1/admin/products/${productId}/inventory-position/send`,
      { dry_run: dryRun },
    );
    return response.data;
  }

  async sendOverallSummary({ dryRun = false } = {}) {
    const response = await apiClient.post(
      '/api/v1/admin/real-inventory/inventory-summary/send',
      { dry_run: dryRun },
    );
    return response.data;
  }
}

const inventoryPositionService = new InventoryPositionService();
export default inventoryPositionService;
